import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "kn-page-content p-grid p-m-0" }
const _hoisted_2 = { class: "p-col-4 p-sm-4 p-md-3 p-p-0" }
const _hoisted_3 = {
  class: "kn-list-item",
  "data-test": "list-item"
}
const _hoisted_4 = { class: "kn-list-item-text" }
const _hoisted_5 = { class: "kn-list-item-text-secondary" }
const _hoisted_6 = { class: "kn-list--column p-col-8 p-sm-8 p-md-9 p-p-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FabButton = _resolveComponent("FabButton")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_Avatar = _resolveComponent("Avatar")
  const _component_Button = _resolveComponent("Button")
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_KnHint = _resolveComponent("KnHint")
  const _component_DriversManagementDetail = _resolveComponent("DriversManagementDetail")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.driversManagement.title')), 1)
        ]),
        end: _withCtx(() => [
          _createVNode(_component_FabButton, {
            icon: "fas fa-plus",
            onClick: _ctx.showForm,
            "data-test": "open-form-button"
          }, null, 8, ["onClick"])
        ]),
        _: 1
      }),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate",
            class: "kn-progress-bar",
            "data-test": "progress-bar"
          }))
        : _createCommentVNode("", true),
      (!_ctx.loading)
        ? (_openBlock(), _createBlock(_component_Listbox, {
            key: 1,
            class: "kn-list--column",
            options: _ctx.drivers,
            optionLabel: "label",
            filter: true,
            filterPlaceholder: _ctx.$t('common.search'),
            filterMatchMode: "contains",
            filterFields: _ctx.driversManagementDescriptor.filterFields,
            emptyFilterMessage: _ctx.$t('common.info.noDataFound'),
            onChange: _ctx.showForm,
            "data-test": "drivers-list"
          }, {
            empty: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
            ]),
            option: _withCtx((slotProps) => [
              _createVNode("div", _hoisted_3, [
                _withDirectives(_createVNode(_component_Avatar, {
                  icon: _ctx.driversManagementDescriptor.iconTypesMap[slotProps.option.type].icon,
                  style: _ctx.driversManagementDescriptor.iconTypesMap[slotProps.option.type].style,
                  shape: "circle",
                  size: "medium"
                }, null, 8, ["icon", "style"]), [
                  [_directive_tooltip, _ctx.driversManagementDescriptor.iconTypesMap[slotProps.option.type].tooltip]
                ]),
                _withDirectives(_createVNode("div", _hoisted_4, [
                  _createVNode("span", null, _toDisplayString(slotProps.option.label), 1),
                  _createVNode("span", _hoisted_5, _toDisplayString(slotProps.option.name), 1)
                ], 512), [
                  [
                    _directive_tooltip,
                    slotProps.option.description,
                    void 0,
                    { top: true }
                  ]
                ]),
                _createVNode(_component_Button, {
                  icon: "far fa-trash-alt",
                  class: "p-button-text p-button-rounded p-button-plain",
                  onClick: _withModifiers(($event: any) => (_ctx.deleteDriverConfirm(slotProps.option.id)), ["stop"]),
                  "data-test": "delete-button"
                }, null, 8, ["onClick"])
              ])
            ]),
            _: 1
          }, 8, ["options", "filterPlaceholder", "filterFields", "emptyFilterMessage", "onChange"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_6, [
      (!_ctx.formVisible)
        ? (_openBlock(), _createBlock(_component_KnHint, {
            key: 0,
            title: 'managers.driversManagement.title',
            hint: 'managers.driversManagement.hint'
          }, null, 8, ["title", "hint"]))
        : (_openBlock(), _createBlock(_component_DriversManagementDetail, {
            key: 1,
            selectedDriver: _ctx.selectedDriver,
            onCreated: _ctx.handleSave,
            onClose: _ctx.closeForm,
            onTouched: _cache[1] || (_cache[1] = ($event: any) => (_ctx.touched = true))
          }, null, 8, ["selectedDriver", "onCreated", "onClose"]))
    ])
  ]))
}